import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createNewSupplier = async (values, callback) => {
    const res = await axios.post(`/supplier/createsupplier`, values);
    console.log("Supplier data : ", values)

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response)
    }
}

export const updateSupplier = async (id, values, callback) => {
    const res = await axios.put(`/supplier/updatesupplier/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deleteSupplier = async (id, userid, callback) => {
    const res = await axios.put(`/supplier/deletesupplier/${id}`, { updatedBy: userid });

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getAllSuppliers = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/supplier/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
    if (res.status === 200) {
        const supplierList = res.data.response.data;
        callback(supplierList)
    } else {
        callback(res.data.response);
    }
}

export const getSuppliers = async (callback) => {
    const res = await axios.get(`/supplier/allsuppliers`);

    if (res.status === 200) {
        const supplierList = res.data.response.data;
        callback(supplierList)
    } else {
        callback(res.data.response);
    }
}

export const getSupplierById = async (id, callback) => {
    axios.get(`/supplier/${id}`).then(res => {

        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data)
        }
    })

}


export const SupplierAPI = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [allSuppliers, setAllSuppliers] = useState([])
    const [supplierDetail, setSupplierDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0);

    useEffect(() => {
        getAllSuppliers(rowPerPage, pageNumber, search, res => {
            setSuppliers(res);
            setTotalPages(res.totalPage || 1)
        })

        getSupplierById(id, res => {
            setSupplierDetail(res);
        })

        getSuppliers(res => {
            setAllSuppliers(res)
        })
    }, [callback, rowPerPage, search, pageNumber, id])

    return {
        suppliers: [suppliers, setSuppliers],
        supplierDetail: [supplierDetail, setSupplierDetail],
        allSuppliers: [allSuppliers, setAllSuppliers],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}